import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { motion } from "framer-motion";

const CriticalMomentItem = ({ svg, title, description }) => {
  return (
    <Container>
      <Line>
        {svg}
        <Title>{title}</Title>
      </Line>
      <Description>{description}</Description>
    </Container>
  );
};

export default CriticalMomentItem;
const Container = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: fit-content;
  gap: 10px;
  margin: auto;
  background: ${lightThemeColors.darkColor};
  border-radius: 10px;
  border: 1px solid rgba(237, 235, 234, 1);
  @media (max-width: 990px) {
    width: 100%;
  }
`;

const Title = styled.h3`
  color: ${lightThemeColors.lightColor};
  font-weight: 700;
  font-size: 20px;
  line-height: 30px @media (max-width: 990px) {
    font-size: 24px;
    line-height: 30px;
  }
`;
const Description = styled.p`
  color: ${lightThemeColors.lightColorFaded7};
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  @media (max-width: 990px) {
    font-size: 16px;
    line-height: 22px;
  }
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;

  svg {
    width: 24px;
    height: 24px;
  }
`;
